import React, { useEffect, useState } from "react";
import {
  useParams,
  useNavigate,
} from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import { useSelector, useDispatch } from "react-redux";
import { CompletedIcon, FailedIcon } from "../../Static/icons/iconshere";
import { operationStatus, syncResourceTypeText } from "../../utils/constants";
import apiClient from "../../apiClient";
import { PUBLISH_OPERATION_STATUS } from "../../apiClient/apiEndpoints";


const DeployPage = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const params = useParams();
  const id = params.id;
  const configData = useSelector((state) => state.configSlice);
  const userData = useSelector((state) => state.userSlice);
  const [recallStatus, setRecallStatus] = useState(false);
  const [allChannelList, setAllChannelList] = useState([]);
  const [operations, setOperations] = useState([]);
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);


  const getAllUpdateStatus = async () => {
    try {
      let data = await apiClient(`${configData.config.UNO_URL}${PUBLISH_OPERATION_STATUS}/${id}`)
      
      setOperations(data.list);
      setRecallStatus(data.shouldRecall);

    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getAllUpdateStatus();

  // If recallStatus is true, start polling the API
    if (recallStatus) {
      const intervalId = setInterval(() => {
        getAllUpdateStatus();
      }, 750);

      return () => clearInterval(intervalId);
    }
  }, [recallStatus]);



  return (
    <div className="container-fluid" data-aos="fade-left">

      <div className="headdetail pb-2">
        <p className="backcrum" onClick={() => navigate(-1)}>
          <i className="bi-chevron-left"></i> Back
        </p>
        {/* <span className="pagetitle">Spark Plug</span> */}
      </div>
      <div className="row">
        <div className="col-12">
          <table className="table deploytable">
            <thead>
              <tr>
                <th scope="col">Actions</th>
                <th></th>
                <th scope="col" className="text-center">
                  Status
                </th>
              </tr>
            </thead>

            <tbody>

              {operations?.map((e, i) => {
                  return (
                      <tr key={i} className={operationStatus[e.status]}>
                        <td> Syncing {syncResourceTypeText[e.type]} {e.directory} </td>

                        <td>

                          {e?.status == "INQUEUE" ?
                            <div className="loader">
                              <span className="hour"></span>
                              <span className="min"></span>
                              <span className="circel"></span>
                            </div>
                            :
                            e?.status == "INPROGRESS" ?
                              <div className="loader">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 512 512"
                                >
                                  <path d="M64 32C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm280 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm48 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM64 288c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V352c0-35.3-28.7-64-64-64H64zm280 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"></path>
                                </svg>
                                <span></span>
                              </div>
                              :
                              e?.status == "COMPLETED" ?
                                <CompletedIcon />
                                :
                                e?.status == "FAILED" ?
                                  <FailedIcon />
                                  :
                                  ""
                          }
                        </td>


                        <td className="text-center">
                          {e.status}
                        </td>

                      </tr>


                  )
                })
 
              }


            </tbody>
          </table>
        </div>
      </div>

    </div>
  );
};

export default DeployPage;
